/**  @jsx jsx */

import { Grid, IconButton, Tooltip } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  wrapper: css`
    display: inline-block;
  `,
};

type Props = {
  isDisabledMoveDown: boolean;
  isDisabledMoveUp: boolean;
  onMoveDown: () => void;
  onMoveUp: () => void;
};

function SortControls(props: Props) {
  const { isDisabledMoveDown, isDisabledMoveUp, onMoveDown, onMoveUp } = props;

  return (
    <div
      css={Styles.wrapper}
      onClick={event => event.stopPropagation()}
      role="presentation"
    >
      <Grid columns="repeat(2, 24px)" gap={8}>
        <Tooltip content="Sort up">
          <IconButton
            aria-label="Sort item up one"
            variant="primary"
            isDisabled={isDisabledMoveUp}
            name="arrowBigUp"
            onPress={onMoveUp}
            size="small"
          />
        </Tooltip>
        <Tooltip content="Sort down">
          <IconButton
            aria-label="Sort item down one"
            variant="primary"
            isDisabled={isDisabledMoveDown}
            name="arrowBigDown"
            onPress={onMoveDown}
            size="small"
          />
        </Tooltip>
      </Grid>
    </div>
  );
}

export default SortControls;
